import { css } from '@linaria/core';

import { commonButtonBaseList } from '../constants';
import type { Size } from '../types';

const generateStyle = (size: Size) => `
	gap: ${commonButtonBaseList[size].gap};
	padding-left: calc(${commonButtonBaseList[size].paddingX} + var(--additional-padding-x));
	padding-right: calc(${commonButtonBaseList[size].paddingX} + var(--additional-padding-x));
	--button-icon-size: ${commonButtonBaseList[size].iconSize};
	--button-icon-padding: ${commonButtonBaseList[size].iconPadding};
`;

export const styledButton = css`
	&.sizeBadge {
		${generateStyle('S')}
	}

	&.sizeS {
		${generateStyle('S')}
	}

	&.sizeM {
		${generateStyle('M')}
	}

	&.sizeL {
		${generateStyle('L')}
	}
`;
